import { Injectable } from '@angular/core';
import { NewsStore } from './news.store';
import { NewsModel } from 'src/app/models/NewsModel';
import { Observable } from 'rxjs';
import { ConstantsStore } from '../constants.store';
import { ApiService } from '../api-service';
import {NewsType} from '../../../models/enums/newsType';
import {MatDialog} from '@angular/material/dialog';
import {PopupNewsModalComponent} from '../../../shared/dialogs/popup-news-modal/popup-news-modal.component';
import {Router} from '@angular/router';
import {DeviceDetectorService} from 'ngx-device-detector';

@Injectable({
  providedIn: 'root'
})
export class NewsService {

  constructor(
    private store: NewsStore,
    private constants: ConstantsStore,
    private apiService: ApiService,
    private dialog: MatDialog,
    private router: Router,
    private device: DeviceDetectorService
  ) { }

  public get(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.apiGet()
        .toPromise()
        .then(
          (res: NewsModel[]) => {
            this.store.totalRecords = res.length;
            this.store.loadNews(res);

            this.handlePopupNewsDialog();

            resolve(true);
          },
          (error: any) => reject(error)
        );
    });
  }

  getData(): Observable<any> {
    return new Observable(observer => {
      this.apiGet()
        .subscribe(
          (res: NewsModel[]) => {
            this.store.totalRecords = res.length;
            this.store.loadNews(res);

            this.handlePopupNewsDialog();

            observer.next(res);
          },
          (err) => {
            observer.error(err);
          }
        );
    });
  }

  private handlePopupNewsDialog() {
    if (!this.device.isDesktop()) { return; }

    if (this.router.url.includes('gestione') ||
      this.router.url.includes('public-news')) {
      return;
    }

    if (!this.store.news.some(news => news.type === NewsType.Popup)) {
      return;
    }

    const popupArticles = this.store.news.filter(news => news.type === NewsType.Popup);
    const popupArticle = popupArticles.length === 1
      ? popupArticles[0]
      : popupArticles.sort((a, b) => b.position - a.position)[0];

    if (localStorage.getItem('popupNews') === `${popupArticle.id}`) {
      return;
    }

    this.dialog.open(PopupNewsModalComponent, {
      disableClose: true,
      data: popupArticle,
    });
  }

  deleteData(id: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.apiDelete(id)
        .toPromise()
        .then(
          (res: any) => {
            resolve(true);
          },
          (err) => {
            reject(err);
          },
        );
    });
  }

  updatePositions(news: NewsModel[]) {
    return new Promise((resolve, reject) => {

      const positionsById: { [key: number]: number } = {};
      news.forEach(n => positionsById[n.id] = n.position);
      this.apiPatch(positionsById)
        .toPromise()
        .then(
          () => {
            resolve(true);
          }
        )
        .catch(err => {
          reject(err);
        }
        );
    });
  }


  /* API Calls*/
  private apiGet() {
    return this.apiService.getTableRecordsNoCacheBasic<NewsModel[]>(this.constants.newsUrl);
  }
  private apiPatch(toUpdate: any) {
    return this.apiService.patch(this.constants.newsUrl, toUpdate);
  }
  public apiPost(newsToAdd: NewsModel) {
    const numb: number = newsToAdd.type;
    newsToAdd.type = numb;
    // console.log(numb);
    // console.log(newsToAdd.type);
    // console.log(newsToAdd);
    return this.apiService.post<NewsModel>(this.constants.newsUrl, newsToAdd);
  }
  private apiDelete(id: number) {
    return this.apiService.delete(this.constants.newsUrl, id);
  }
}
